import {post} from "../utils";
import {makeFormData} from "./utils";

const createFromDemo = host => {
  return data => post(`${host}/users/createFromDemo`, makeFormData(data));
};

export default createFromDemo;